// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__2f6KE","input":"styles_input__3qQVm","title":"styles_title__1fKcg","icon":"styles_icon__1tLl3"};